// React
import React, { useEffect, useState } from "react";
// MUI
import { Card, Stack, Button, Container, Typography } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
import GoDrawer from "../../../components/Inputs/GoDrawer";
import Voucher from "./Voucher";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import PermissionConstants from "../../../configs/PermissionConstants";
// Services
import { get } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Hooks
import usePermissions from "../../../hooks/usePermissions";

import { VOUCHER_TABLE_HEADS, voucherTypeList } from "./Voucher.utils";
import GoSelect from "../../../components/Inputs/GoSelect";
import Filter from "./Filter";

const Vouchers = () => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [config, setConfig] = useState({});

    const [open, setOpen] = useState(false);
    const [id, setId] = useState(undefined);
    const [openFilter, setOpenFilter] = useState(false);
    const [filter, setFilter] = useState({
        sort: "id",
        order: "desc",
        max: 10,
        offset: 0,
        search: "",
        queryFilters: "{}"
    });

    const [vouchers, setVouchers] = useState({
        entries: [],
        total_count: 0
    });

    const getVouchers = async () => {
        spinService.on();
        const response = await get(EntityConstants.VOUCHERS, `sort=${filter.sort}&order=${filter.order}&max=${filter.max}&offset=${filter.offset + 1}&search=${filter.search}&type=${config.name}&queryFilters=${filter.queryFilters}`);
        const data = await response.json();
        setVouchers(data);
        spinService.off();
    };

    const onClose = () => {
        getVouchers();
        setOpen(false);
        setOpenFilter(false);

    };

    const handleVoucherTypeChange = (e) => {
        setConfig(e.target.value);
    };

    useEffect(() => {
        if (config.name === undefined) {
            setConfig(voucherTypeList[0]);
        }
        if (config.name !== undefined) {
            getVouchers();
        }
    }, [filter, config.name]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h6"
                        component="div" sx={{ flexGrow: 1 }}>
                        {config.title}
                    </Typography>
                    <GoSelect
                        title="Select Voucher"
                        name="master"
                        value={config}
                        items={voucherTypeList}
                        displayKey="name"
                        itemValue="fullItem"
                        handleChange={(e) => handleVoucherTypeChange(e)}
                        size="small"
                    />
                    {
                        (
                            (config.name === "Payment Voucher" && permissions.has(PermissionConstants.PAYMENT_VOUCHER_CREATE)) ||
                            (config.name === "Journal Voucher" && permissions.has(PermissionConstants.JOURNAL_VOUCHER_CREATE)) ||
                            (config.name === "Prepayment Voucher" && permissions.has(PermissionConstants.PREPAYMENT_VOUCHER_CREATE)) ||
                            (config.name === "PDC Bank Payment" && permissions.has(PermissionConstants.PDC_BANK_PAYMENT_CREATE))) &&
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="eva:plus-fill" />}
                            onClick={() => { setId(undefined); setOpen(true) }}
                        >
                            {config.name === "PDC Bank Payment" ? 'New Payment' : 'New Voucher'}
                        </Button>
                    }
                </Stack>
                <Card>
                    <GoTable
                        tableHeads={VOUCHER_TABLE_HEADS}
                        tableDatas={vouchers.entries}
                        totalCount={vouchers.total_count}
                        filter={filter}
                        onFilter={(filter) => setFilter((prevState) => {
                            return {
                                ...prevState,
                                sort: filter.sort,
                                order: filter.order,
                                max: filter.max,
                                offset: filter.offset,
                                search: filter.search,
                            }
                        })}
                        onView={(row) => { setId(row.id); setOpen(true) }}
                        openFilter={() => setOpenFilter(true)}
                        customFilter={true}
                    />
                </Card>
            </Container>

            {
                permissions.has(PermissionConstants.RECEIPT_VIEW) && open && <GoDrawer
                    minwidth="80%"
                    title={config.name}
                    open={open}
                    onClose={() => onClose()}
                >
                    <Voucher voucherType={config.name} id={id} onClose={() => onClose()} />
                </GoDrawer>
            }
            {
                openFilter && <Filter
                    queryFilters={filter.queryFilters}
                    openFilter={openFilter}
                    onClose={() => onClose()}
                    onFilters={(filterQuries) => setFilter((prevState) => { return { ...prevState, queryFilters: JSON.stringify(filterQuries) } })} />
            }

        </React.Fragment>
    );
}

export default Vouchers;